import {
  useEffect,
  useState,
} from "react";

function getMatrixMediaUrl(
  client,
  mxcUrl,
  options = {}
) {
  if (!client || !mxcUrl) {
    return "";
  }

  if (!mxcUrl.startsWith("mxc://")) {
    return mxcUrl;
  }

  const {
    width,
    height,
    resizeMethod = "scale",
  } = options;

  // Только изображения с размерами получают thumbnail.
  if (width || height) {
    return (
      client.mxcUrlToHttp(
        mxcUrl,
        width,
        height,
        resizeMethod,
        false,
        true,
        true
      ) || ""
    );
  }

  // Аудио / видео / файлы:
  // обычный authenticated media download,
  // БЕЗ thumbnail.
  return (
    client.mxcUrlToHttp(
      mxcUrl,
      undefined,
      undefined,
      undefined,
      false,
      true,
      true
    ) || ""
  );
}

export default function useMatrixMedia(
  client,
  mxcUrl,
  options = {}
) {
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    let objectUrl = "";

    async function loadMedia() {
      if (!client || !mxcUrl) {
        setUrl("");
        setLoading(false);
        setError(null);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const mediaUrl =
          getMatrixMediaUrl(
            client,
            mxcUrl,
            options
          );

        if (!mediaUrl) {
          throw new Error(
            "Не удалось получить URL Matrix media"
          );
        }

        const accessToken =
          client.getAccessToken?.();

        if (!accessToken) {
          throw new Error(
            "Matrix access token отсутствует"
          );
        }

        const response =
          await fetch(mediaUrl, {
            method: "GET",
            headers: {
              Authorization:
                `Bearer ${accessToken}`,
            },
          });

        if (!response.ok) {
          let message =
            `HTTP ${response.status}`;

          try {
            const data =
              await response.json();

            if (data?.error) {
              message = data.error;
            }
          } catch {
            // ignore
          }

          throw new Error(message);
        }

        const blob =
          await response.blob();

        objectUrl =
          URL.createObjectURL(blob);

        if (!active) {
          URL.revokeObjectURL(objectUrl);
          objectUrl = "";
          return;
        }

        setUrl(objectUrl);
      } catch (err) {
        console.error(
          "[MATRIX MEDIA] Ошибка загрузки:",
          err
        );

        if (active) {
          setUrl("");
          setError(
            err?.message ||
            "Не удалось загрузить файл"
          );
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    loadMedia();

    return () => {
      active = false;

      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [
    client,
    mxcUrl,
    options.width,
    options.height,
    options.resizeMethod,
  ]);

  return {
    url,
    loading,
    error,
  };
}